import React from "react"

// components
import Shop from "./Shop"
import Buddy from "./Buddy"

// styling
import "./App.scss"

// print version
const version = {
  major:1, minor:3, patch:0
}
console.log(`v${version.major}.${version.minor}.${version.patch}`)

// the component
function App() {
  // which mode? shop or buddy?
  let mode = process.env.REACT_APP_MODE || 'shop'

  // render
  if(mode === 'shop') {
    return <Shop />
  }
  else {
    return <Buddy />
  }
}

export default App
